import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import FormInput from '../../../../../library/form/components/FormInput';
import FormWrapper from "../../../../../library/form/components/FormWrapper";
import FormCheckbox from '../../../../../library/form/components/FormCheckbox';

const ProdIOOOmrAddRow = (props) => {
    const { formObject, index, rowKey } = props;

        return (
            <ul className="uiDPEditLine">
                <li className="uiColumnCenter uiColumn30">
                    <span>{index}</span>
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemId" }} />
                </li>
                <li className="uiColumnCenter uiColumn150">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "actualItem", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <li className="uiColumnCenter uiColumn30">
                    <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "units" }} />
                </li>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn50" headerKey="viewConfig"
                    action={{ paramName: "variation1Name" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation1" }} />
                </FormWrapper>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn50" headerKey="viewConfig"
                    action={{ paramName: "variation2Name" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation2" }} />
                </FormWrapper>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyAvail" }} />
                </li>
                <li className="uiColumnCenter uiColumn150">
                    <div style={{float:"left"}}> 
                        <FormInput formObject={formObject} className="uiWidth55 uiSpacerH5" rowKey={rowKey} 
                            action={{ InputType: "input", actionId: "refresh", paramName: 'retQty1', 
                            actionParam: {formulaSource: "RQ1", updateQty : "1", actionType:"updateQty" }}} />
                        <FormInput formObject={formObject} className="uiWidth55" rowKey={rowKey} 
                            action={{ InputType: "input", actionId: "refresh", paramName: 'retQty2', 
                            actionParam: {formulaSource: "RQ2", updateQty : "1", actionType:"updateQty" }}} />
                    </div>
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormInput style={{width:"68px"}} formObject={formObject} rowKey={rowKey} 
                        action={{ InputType: "input", actionId: "refresh", paramName: "resUnitCost", 
                        actionParam:{formulaSource: "RC", updateQty : "1", actionType:"updateCost" }}}/>
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormInput style={{width:"68px"}} formObject={formObject} rowKey={rowKey} 
                        action={{ InputType: "input", actionId: "refresh", paramName: "processUnitCost", 
                        actionParam:{formulaSource: "RC", updateQty : "1", actionType:"updateCost" }}}/>
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormInput style={{width:"68px"}} formObject={formObject} rowKey={rowKey} 
                        action={{ InputType: "input", actionId: "refresh", paramName: "ohUnitCost", 
                        actionParam:{formulaSource: "RC", updateQty : "1", actionType:"updateCost" }}}/>
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue formObject={formObject} rowKey={rowKey}
                        action={{ paramName: "totalUnitCost" }}/>
                </li>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn50" headerKey="viewConfig"
                    action={{ paramName: "showAIC" }} >
                    <FormCheckbox formObject={formObject} rowKey={rowKey} className="" action={{ InputType: "onOff", paramName: "isAIC" }} />
                </FormWrapper>
            </ul>
        )
}

export default ProdIOOOmrAddRow